module.exports = __webpack_public_path__ + "static/media/weight.54bf8558.svg";